import React, { useState, useContext, useEffect, useRef } from "react";
import Main from "../components/layout/Main";
import { Button, Col, Input, Row, Select } from "antd";
import Search from "antd/lib/transfer/search";
import PostUser from "../assets/images/post-user.png";
import Post1 from "../assets/images/post-1.png";
import Comment from "../assets/images/comment.svg";
import Like from "../assets/images/like.svg";
import ScoreCard from "../assets/images/score-card.svg";
import avtarImg from "../assets/images/avtarImg.png";
import trophyIcon from "../assets/images/trophyIcon.png";
import backArrow from "../assets/images/backArrow.png";
import closeIconDark from "../assets/images/closeIconDark.png";
import tabIcon1 from "../assets/images/tabIcon1.png";
import noteIcon from "../assets/images/noteIcon.png";
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';  
import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
import golfIcon from "../assets/images/golfIcon.png";
import shareIcon from "../assets/images/shareIcon.png";
import gameImg from "../assets/images/gameImg.png";
import { useNavigate, useLocation } from "react-router-dom";
import useRequest from "../hooks/useRequest";

function CurrentLeaderboard() {
  const { request } = useRequest();
  const navigate = useNavigate();
  const [leaderboards, setLeaderboards] = useState({
    created: [],
    joined: [],
    invited: []
  });
  const [friendsLeaderboards, setFriendsLeaderboards] = useState([]);
  const [selectedLeaderboard, setSelectedLeaderboard] = useState(null);
  const [joinPassword, setJoinPassword] = useState("");
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [loading, setLoading] = useState({
    main: true,
    friends: true
  });
  
  const [show, scoreCardStepModal] = useState(false);
  const scoreCardStepModalClose = () => scoreCardStepModal(false);
  const scoreCardStepModalOpen = () => scoreCardStepModal(true);

  useEffect(() => {
    fetchLeaderboards();
    fetchFriendsLeaderboards();
  }, []);

  const fetchLeaderboards = () => {
    setLoading(prev => ({ ...prev, main: true }));
    request({
      url: "/app/leaderboard/my-leaderboards",
      method: "GET",
      onSuccess: (data) => {
        console.log("My leaderboards data:", data.data);
        setLeaderboards(data.data || { created: [], joined: [], invited: [] });
        setLoading(prev => ({ ...prev, main: false }));
      },
      onError: (error) => {
        console.log("Error fetching leaderboards:", error);
        setLoading(prev => ({ ...prev, main: false }));
      }
    });
  };

  const fetchFriendsLeaderboards = () => {
    setLoading(prev => ({ ...prev, friends: true }));
    request({
      url: "/app/leaderboard/friends/leaderboards",
      method: "GET",
      onSuccess: (data) => {
        console.log("Friends leaderboards data:", data);
        // Handle both array response and object response
        const friendsData = Array.isArray(data.data) ? data.data : 
                          (data.data && Array.isArray(data.data.data)) ? data.data.data : 
                          (data.data && Array.isArray(data.data.leaderboards)) ? data.data.leaderboards : [];
        
        setFriendsLeaderboards(friendsData);
        setLoading(prev => ({ ...prev, friends: false }));
      },
      onError: (error) => {
        console.log("Error fetching friends leaderboards:", error);
        setFriendsLeaderboards([]);
        setLoading(prev => ({ ...prev, friends: false }));
      }
    });
  };

  const handleJoinLeaderboard = (leaderboard) => {
    setSelectedLeaderboard(leaderboard);
    setShowJoinModal(true);
  };

  const submitJoin = () => {
    request({
      url: "/app/leaderboard/join",
      method: "POST",
      data: {
        leaderboardId: selectedLeaderboard._id,
        leaderPassword: joinPassword
      },
      onSuccess: (data) => {
        setShowJoinModal(false);
        setJoinPassword("");
        fetchLeaderboards();
        fetchFriendsLeaderboards();
      },
      onError: (error) => {
        console.log("Error joining leaderboard:", error);
        alert("Failed to join: " + (error.response?.data?.message || "Invalid password"));
      }
    });
  };

  const LeaderboardCard = ({ leaderboard, type }) => {
    // Safely extract user data - handle different response structures
    const userData = leaderboard.user || {};
    const userName = userData.name || userData.userName || leaderboard.leaderName || 'Unknown';
    const userProfilePic = userData.profilePic || null;
    
    // Safely extract course data
    const courseData = leaderboard.course || {};
    const courseName = courseData.name || courseData.courseName || "Unknown Course";
    
    return (
      <div className="col-xxl-4 col-md-6">
        <div className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
          <div className="organizerProfile">
            <div className="organizerDetail d-flex align-items-center gap-2">
              <div className="imgOuter rounded-circle overflow-hidden" style={{width: '40px', height: '40px'}}>
                <img 
                  className="w-100 h-100 object-fit-cover" 
                  src={
                    userProfilePic 
                      ? `https://pwabucket1.s3.amazonaws.com/${userProfilePic}` 
                      : `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&size=256`
                  } 
                  alt={userName}
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&size=256`;
                  }}
                />
              </div>
              <div className="detail w-100">
                <div className="name d-flex align-items-center justify-content-between">
                  {leaderboard.name || "Unnamed Leaderboard"}
                  <div className="date">{new Date(leaderboard.date || Date.now()).toLocaleDateString()}</div>
                </div>
                <div className="dec mt-1">
                  {courseName} | {leaderboard.holes || 18} Holes
                </div>
              </div>
            </div>
          </div>
          <div className="leaderProfile">
            <div className="row g-2">
              <div className="col-6 text-start">
                <div className="value">{leaderboard.type || "Individual"} Competition</div>
                <div className="title">Type</div>
              </div>
              <div className="col-6 text-end">
                <div className="value">{leaderboard.playerCount || 0}</div>
                <div className="title">Joined</div>
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <button 
              className="btn btn-sm btn-outline-primary"
              onClick={() => navigate(`/leaderboard/${leaderboard._id}`)}
            >
              View Details
            </button>
            {(type === "invited" || type === "friends") && (
              <button 
                className="btn btn-sm btn-primary"
                onClick={() => handleJoinLeaderboard(leaderboard)}
              >
                Join
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  if (loading.main || loading.friends) {
    return (
      <Main>
        <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
          <div className="d-flex justify-content-center align-items-center" style={{height: '50vh'}}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </section>
      </Main>
    );
  }

  return (
    <Main>
      <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
        <div className="row g-3">
          <div className="col-lg-12">
            <div className="pageHeadign">
              <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
                <button onClick={()=>navigate("/play")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
                  <img className="h-100" src={backArrow} alt="Back"/>        
                </button> 
                <div className="txt">Leaderboard</div>
              </div>
            </div>
          </div>

          <Tabs defaultActiveKey="joined" className="mb-3">
            <Tab eventKey="joined" title="Joined Leaderboards">
              <div className="row g-3">
                {leaderboards.joined && leaderboards.joined.length > 0 ? (
                  leaderboards.joined.map(leaderboard => (
                    <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="joined" />
                  ))
                ) : (
                  <div className="col-12">
                    <div className="alert alert-info">You haven't joined any leaderboards yet.</div>
                  </div>
                )}
              </div>
            </Tab>
            
            <Tab eventKey="created" title="My Leaderboards">
              <div className="row g-3">
                {leaderboards.created && leaderboards.created.length > 0 ? (
                  leaderboards.created.map(leaderboard => (
                    <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="created" />
                  ))
                ) : (
                  <div className="col-12">
                    <div className="alert alert-info">You haven't created any leaderboards yet.</div>
                  </div>
                )}
              </div>
            </Tab>
            
            <Tab eventKey="invited" title="Invitations">
              <div className="row g-3">
                {leaderboards.invited && leaderboards.invited.length > 0 ? (
                  leaderboards.invited.map(leaderboard => (
                    <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="invited" />
                  ))
                ) : (
                  <div className="col-12">
                    <div className="alert alert-info">You don't have any pending invitations.</div>
                  </div>
                )}
              </div>
            </Tab>

            <Tab eventKey="friends" title="Friends Leaderboards">
              <div className="row g-3">
                {friendsLeaderboards.length > 0 ? (
                  friendsLeaderboards.map(leaderboard => (
                    <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="friends" />
                  ))
                ) : (
                  <div className="col-12">
                    <div className="alert alert-info">No public leaderboards available from friends.</div>
                  </div>
                )}
              </div>
            </Tab>
          </Tabs>
        </div>
      </section>

      <Modal show={showJoinModal} onHide={() => setShowJoinModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Join Leaderboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Enter Password for {selectedLeaderboard?.name}</Form.Label>
              <Form.Control
                type="password"
                value={joinPassword}
                onChange={(e) => setJoinPassword(e.target.value)}
                placeholder="Leaderboard password"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowJoinModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitJoin}>
            Join
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  );
}

export default CurrentLeaderboard;






// import React, { useState, useContext, useEffect, useRef } from "react";
// import Main from "../components/layout/Main";
// import { Button, Col, Input, Row, Select } from "antd";
// import Search from "antd/lib/transfer/search";
// import PostUser from "../assets/images/post-user.png";
// import Post1 from "../assets/images/post-1.png";
// import Comment from "../assets/images/comment.svg";
// import Like from "../assets/images/like.svg";
// import ScoreCard from "../assets/images/score-card.svg";
// import avtarImg from "../assets/images/avtarImg.png";
// import trophyIcon from "../assets/images/trophyIcon.png";
// import backArrow from "../assets/images/backArrow.png";
// import closeIconDark from "../assets/images/closeIconDark.png";
// import tabIcon1 from "../assets/images/tabIcon1.png";
// import noteIcon from "../assets/images/noteIcon.png";
// import Form from 'react-bootstrap/Form';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';  
// import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
// import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
// import golfIcon from "../assets/images/golfIcon.png";
// import shareIcon from "../assets/images/shareIcon.png";
// import gameImg from "../assets/images/gameImg.png";
// import { useNavigate, useLocation } from "react-router-dom";
// import useRequest from "../hooks/useRequest";

// function CurrentLeaderboard() {
//   const { request } = useRequest();
//   const navigate = useNavigate();
//   const [leaderboards, setLeaderboards] = useState({
//     created: [],
//     joined: [],
//     invited: []
//   });
//   const [friendsLeaderboards, setFriendsLeaderboards] = useState([]);
//   const [selectedLeaderboard, setSelectedLeaderboard] = useState(null);
//   const [joinPassword, setJoinPassword] = useState("");
//   const [showJoinModal, setShowJoinModal] = useState(false);
  
//   const [show, scoreCardStepModal] = useState(false);
//   const scoreCardStepModalClose = () => scoreCardStepModal(false);
//   const scoreCardStepModalOpen = () => scoreCardStepModal(true);

//   useEffect(() => {
//     fetchLeaderboards();
//     fetchFriendsLeaderboards();
//   }, []);

//   const fetchLeaderboards = () => {
//     request({
//       url: "/app/leaderboard/my-leaderboards",
//       method: "GET",
//       onSuccess: (data) => {
//         setLeaderboards(data.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching leaderboards:", error);
//       }
//     });
//   };

//   const fetchFriendsLeaderboards = () => {
//     request({
//       url: "/app/leaderboard/friends/leaderboards",
//       method: "GET",
//       onSuccess: (data) => {
//         setFriendsLeaderboards(data.data);
//         console.log("leaders", data.data)
//       },
//       onError: (error) => {
//         console.log("Error fetching friends leaderboards:", error);
//       }
//     });
//   };

//   const handleJoinLeaderboard = (leaderboard) => {
//     setSelectedLeaderboard(leaderboard);
//     setShowJoinModal(true);
//   };

//   const submitJoin = () => {
//     request({
//       url: "/app/leaderboard/join",
//       method: "POST",
//       data: {
//         leaderboardId: selectedLeaderboard._id,
//         leaderPassword: joinPassword
//       },
//       onSuccess: (data) => {
//         setShowJoinModal(false);
//         setJoinPassword("");
//         fetchLeaderboards();
//         fetchFriendsLeaderboards();
//       },
//       onError: (error) => {
//         console.log("Error joining leaderboard:", error);
//         alert("Failed to join: " + (error.response?.data?.message || "Invalid password"));
//       }
//     });
//   };

//   const LeaderboardCard = ({ leaderboard, type }) => (
//     <div className="col-xxl-4 col-md-6">
//       <div className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//         <div className="organizerProfile">
//           <div className="organizerDetail d-flex align-items-center gap-2">
//             <div className="imgOuter rounded-circle overflow-hidden">
//               <img 
//                 className="w-100 h-100" 
//                 src={
//                   leaderboard.user?.profilePic 
//                     ? `https://pwabucket1.s3.amazonaws.com/${leaderboard.user.profilePic}` 
//                     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                         leaderboard.user?.name || 'Unknown'
//                       )}&size=256`
//                 } 
//                 alt={leaderboard.user?.name}
//               />
//             </div>
//             <div className="detail w-100">
//               <div className="name d-flex align-items-center justify-content-between">
//                 {leaderboard.name}
//                 <div className="date">{new Date(leaderboard.date).toLocaleDateString()}</div>
//               </div>
//               <div className="dec mt-1">
//                 {leaderboard.course?.name || "Unknown Course"} | {leaderboard.holes} Holes
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="leaderProfile">
//           <div className="row g-2">
//             <div className="col-6 text-start">
//               <div className="value">{leaderboard.type} Competition</div>
//               <div className="title">Type</div>
//             </div>
//             <div className="col-6 text-end">
//               <div className="value">{leaderboard.playerCount}</div>
//               <div className="title">Joined</div>
//             </div>
//           </div>
//         </div>
//         <div className="d-flex gap-2">
//           <button 
//             className="btn btn-sm btn-outline-primary"
//             onClick={() => navigate(`/leaderboard/${leaderboard._id}`)}
//           >
//             View Details
//           </button>
//           {(type === "invited" || type === "friends") && (
//             <button 
//               className="btn btn-sm btn-primary"
//               onClick={() => handleJoinLeaderboard(leaderboard)}
//             >
//               Join
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-12">
//             <div className="pageHeadign">
//               <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//                 <button onClick={()=>navigate("/play")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                   <img className="h-100" src={backArrow} alt="Back"/>        
//                 </button> 
//                 <div className="txt">Leaderboard</div>
//               </div>
//             </div>
//           </div>

//           <Tabs defaultActiveKey="joined" className="mb-3">
//             <Tab eventKey="joined" title="Joined Leaderboards">
//               <div className="row g-3">
//                 {leaderboards.joined.length > 0 ? (
//                   leaderboards.joined.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="joined" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You haven't joined any leaderboards yet.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
            
//             <Tab eventKey="created" title="My Leaderboards">
//               <div className="row g-3">
//                 {leaderboards.created.length > 0 ? (
//                   leaderboards.created.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="created" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You haven't created any leaderboards yet.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
            
//             <Tab eventKey="invited" title="Invitations">
//               <div className="row g-3">
//                 {leaderboards.invited.length > 0 ? (
//                   leaderboards.invited.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="invited" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You don't have any pending invitations.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>

//             <Tab eventKey="friends" title="Friends Leaderboards">
//               <div className="row g-3">
//                 {friendsLeaderboards.length > 0 ? (
//                   friendsLeaderboards.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="friends" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">No public leaderboards available from friends.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
//           </Tabs>
//         </div>
//       </section>

//       <Modal show={showJoinModal} onHide={() => setShowJoinModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Join Leaderboard</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3">
//               <Form.Label>Enter Password for {selectedLeaderboard?.name}</Form.Label>
//               <Form.Control
//                 type="password"
//                 value={joinPassword}
//                 onChange={(e) => setJoinPassword(e.target.value)}
//                 placeholder="Leaderboard password"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowJoinModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={submitJoin}>
//             Join
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Main>
//   );
// }

// export default CurrentLeaderboard;

// import React, { useState, useContext, useEffect, useRef } from "react";
// import Main from "../components/layout/Main";
// import { Button, Col, Input, Row, Select } from "antd";
// import Search from "antd/lib/transfer/search";
// import PostUser from "../assets/images/post-user.png";
// import Post1 from "../assets/images/post-1.png";
// import Comment from "../assets/images/comment.svg";
// import Like from "../assets/images/like.svg";
// import ScoreCard from "../assets/images/score-card.svg";
// import avtarImg from "../assets/images/avtarImg.png";
// import trophyIcon from "../assets/images/trophyIcon.png";
// import backArrow from "../assets/images/backArrow.png";
// import closeIconDark from "../assets/images/closeIconDark.png";
// import tabIcon1 from "../assets/images/tabIcon1.png";
// import noteIcon from "../assets/images/noteIcon.png";
// import Form from 'react-bootstrap/Form';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';  
// import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
// import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
// import golfIcon from "../assets/images/golfIcon.png";
// import shareIcon from "../assets/images/shareIcon.png";
// import gameImg from "../assets/images/gameImg.png";
// import { useNavigate, useLocation } from "react-router-dom";
// import useRequest from "../hooks/useRequest";

// function CurrentLeaderboard() {
//   const { request } = useRequest();
//   const navigate = useNavigate();
//   const [leaderboards, setLeaderboards] = useState({
//     created: [],
//     joined: [],
//     invited: []
//   });
//   const [selectedLeaderboard, setSelectedLeaderboard] = useState(null);
//   const [joinPassword, setJoinPassword] = useState("");
//   const [showJoinModal, setShowJoinModal] = useState(false);
  
//   const [show, scoreCardStepModal] = useState(false);
//   const scoreCardStepModalClose = () => scoreCardStepModal(false);
//   const scoreCardStepModalOpen = () => scoreCardStepModal(true);

//   useEffect(() => {
//     fetchLeaderboards();
//   }, []);

//   const fetchLeaderboards = () => {
//     request({
//       url: "/app/leaderboard/my-leaderboards",
//       method: "GET",
//       onSuccess: (data) => {
//         setLeaderboards(data.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching leaderboards:", error);
//       }
//     });
//   };

//   const handleJoinLeaderboard = (leaderboard) => {
//     setSelectedLeaderboard(leaderboard);
//     setShowJoinModal(true);
//   };

//   const submitJoin = () => {
//     console.log("leadere", selectedLeaderboard._id, "s", selectedLeaderboard)
//     request({
//       url: "/app/leaderboard/join",
//       method: "POST",
//       data: {
//         leaderboardId: selectedLeaderboard._id,
//         leaderPassword: joinPassword
//       },
//       onSuccess: (data) => {
//         setShowJoinModal(false);
//         setJoinPassword("");
//         fetchLeaderboards(); // Refresh the list
//       },
//       onError: (error) => {
//         console.log("Error joining leaderboard:", error);
//         alert("Failed to join: " + (error.response?.data?.message || "Invalid password"));
//       }
//     });
//   };

//   const LeaderboardCard = ({ leaderboard, type }) => (
//     <div className="col-xxl-4 col-md-6">
//       <div className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//         <div className="organizerProfile">
//           <div className="organizerDetail d-flex align-items-center gap-2">
//             <div className="imgOuter rounded-circle overflow-hidden">
//               <img 
//                 className="w-100 h-100" 
//                 src={leaderboard.user?.profilePic ? `https://pwabucket1.s3.amazonaws.com/${leaderboard.user.profilePic}` : avtarImg} 
//                 alt={leaderboard.user?.name}
//               />
//             </div>
//             <div className="detail w-100">
//               <div className="name d-flex align-items-center justify-content-between">
//                 {leaderboard.name}
//                 <div className="date">{new Date(leaderboard.date).toLocaleDateString()}</div>
//               </div>
//               <div className="dec mt-1">
//                 {leaderboard.course?.name || "Unknown Course"} | {leaderboard.holes} Holes
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="leaderProfile">
//           <div className="row g-2">
//             <div className="col-6 text-start">
//               <div className="value">{leaderboard.type} Competition</div>
//               <div className="title">Type</div>
//             </div>
//             <div className="col-6 text-end">
//               <div className="value">{leaderboard.playerCount}</div>
//               <div className="title">Joined</div>
//             </div>
//           </div>
//         </div>
//         <div className="d-flex gap-2">
//           <button 
//             className="btn btn-sm btn-outline-primary"
//             onClick={() => navigate(`/leaderboard/${leaderboard._id}`)}
//           >
//             View Details
//           </button>
//           {type === "invited" && (
//             <button 
//               className="btn btn-sm btn-primary"
//               onClick={() => handleJoinLeaderboard(leaderboard)}
//             >
//               Join
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-12">
//             <div className="pageHeadign">
//               <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//                 <button onClick={()=>navigate("/play")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                   <img className="h-100" src={backArrow} alt="Back"/>        
//                 </button> 
//                 <div className="txt">Leaderboard</div>
//               </div>
//             </div>
//           </div>

//           <Tabs defaultActiveKey="joined" className="mb-3">
//             <Tab eventKey="joined" title="Joined Leaderboards">
//               <div className="row g-3">
//                 {leaderboards.joined.length > 0 ? (
//                   leaderboards.joined.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="joined" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You haven't joined any leaderboards yet.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
            
//             <Tab eventKey="created" title="My Leaderboards">
//               <div className="row g-3">
//                 {leaderboards.created.length > 0 ? (
//                   leaderboards.created.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="created" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You haven't created any leaderboards yet.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
            
//             <Tab eventKey="invited" title="Invitations">
//               <div className="row g-3">
//                 {leaderboards.invited.length > 0 ? (
//                   leaderboards.invited.map(leaderboard => (
//                     <LeaderboardCard key={leaderboard._id} leaderboard={leaderboard} type="invited" />
//                   ))
//                 ) : (
//                   <div className="col-12">
//                     <div className="alert alert-info">You don't have any pending invitations.</div>
//                   </div>
//                 )}
//               </div>
//             </Tab>
//           </Tabs>
//         </div>
//       </section>

//       {/* Join Modal */}
//       <Modal show={showJoinModal} onHide={() => setShowJoinModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Join Leaderboard</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3">
//               <Form.Label>Enter Password for {selectedLeaderboard?.name}</Form.Label>
//               <Form.Control
//                 type="password"
//                 value={joinPassword}
//                 onChange={(e) => setJoinPassword(e.target.value)}
//                 placeholder="Leaderboard password"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowJoinModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={submitJoin}>
//             Join
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Main>
//   );
// }

// export default CurrentLeaderboard;







// import React, { useState, useContext, useEffect, useRef } from "react";
// import Main from "../components/layout/Main";
// import { Button, Col, Input, Row, Select } from "antd";
// import Search from "antd/lib/transfer/search";
// import PostUser from "../assets/images/post-user.png";
// import Post1 from "../assets/images/post-1.png";
// import Comment from "../assets/images/comment.svg";
// import Like from "../assets/images/like.svg";
// import ScoreCard from "../assets/images/score-card.svg";
// import avtarImg from "../assets/images/avtarImg.png";
// import trophyIcon from "../assets/images/trophyIcon.png";
// import backArrow from "../assets/images/backArrow.png";
// import closeIconDark from "../assets/images/closeIconDark.png";
// import tabIcon1 from "../assets/images/tabIcon1.png";
// import noteIcon from "../assets/images/noteIcon.png";
// import Form from 'react-bootstrap/Form';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import Table from 'react-bootstrap/Table';
// import Modal from 'react-bootstrap/Modal';  
// import logoVerticaleTheme from "../assets/images/logoVerticaleTheme.png";
// import scoreCardModalImg from "../assets/images/scoreCardModalImg.png";
// import golfIcon from "../assets/images/golfIcon.png";
// import shareIcon from "../assets/images/shareIcon.png";
// import gameImg from "../assets/images/gameImg.png";
// import { useNavigate, useLocation } from "react-router-dom";

// function CurrentLeaderboard() {
  
//   const navigate = useNavigate();
  
//   const [show, scoreCardStepModal] = useState(false);
//   const scoreCardStepModalClose = () => scoreCardStepModal(false);
//   const scoreCardStepModalOpen = () => scoreCardStepModal(true);
//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-12">
//             <div className="pagreHeader">
//               <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//                 <button onClick={()=>navigate("/play")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                   <img className="h-100" src={backArrow}/>        
//                 </button> 
//                 <div className="txt">Leaderboard</div>
//               </div>
//             </div>
//           </div>
//           <div className="col-12">
//             <div className="row g-3">
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//               <div className="col-xxl-4 col-md-6">
//                 <a role="button" onClick={scoreCardStepModalOpen} className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-3">
//                   <div className="organizerProfile">
//                     <div className="organizerDetail d-flex align-items-center gap-2">
//                       <div className="imgOuter rounded-circle overflow-hidden">
//                         <img className="w-100 h-100" src={avtarImg}/>
//                       </div>
//                       <div className="detail w-100">
//                         <div className="name d-flex align-items-center justify-content-between">The Belfry Cup <div className="date">12/29/23</div></div>
//                         <div className="dec mt-1">The Belfry Golf Club l Brabazon</div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="leaderProfile">
//                     <div className="row g-2">
//                       <div className="col-6 text-start">
//                         <div className="value">Individual Competition</div>
//                         <div className="title">Type</div>
//                       </div>
//                       <div className="col-6 text-end">
//                         <div className="value">12</div>
//                         <div className="title">Joined</div>
//                       </div>
//                     </div>
//                   </div>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     {/* Score card Modal  */}
//     <Modal show={show} size="lg" className="headerModals" onHide={scoreCardStepModalClose} centered>
//       <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
//         <Modal.Title>
//           <img src={logoVerticaleTheme}/>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="p-sm-4 p-3">
//         <div className="eventcard h-100 rounded-3 bg-white d-flex flex-column gap-12 p-0">
//           <div className="organizerProfile d-flex align-items-center justify-content-between">
//             <div className="organizerDetail d-flex align-items-center gap-2">
//               <div className="imgOuter rounded-circle overflow-hidden">
//                 <img className="w-100 h-100" src={avtarImg}/>
//               </div>
//               <div className="detail">
//                 <div className="name">John Doe</div>
//                 <div className="dec mt-1">Organizer</div>
//               </div>
//             </div>
//             <div className="leaderProfile text-end">
//               <div className="value">0</div>
//               <div className="title">Golfers Joined</div>
//             </div>
//           </div>
//           <div className="leaderProfile">
//             <div className="row g-2">
//               <div className="col-sm-6 text-start">
//                 <div className="value">Dummy Name</div>
//                 <div className="title">Leaderboard Name</div>
//               </div>
//               <div className="col-sm-6 text-sm-end">
//                 <div className="value">Individual Competition</div>
//                 <div className="title">Competition Type</div>
//               </div>
//             </div>
//           </div>
//           <hr className="border-top border-secondary m-0"/>
//           <div className="gameDetail d-flex align-items-center gap-2">
//             <div className="imgOuter">
//               <img className="w-100 h-100" src={gameImg}/>
//             </div>
//             <div className="detail">
//               <div className="gameTitle">Makena Golf & Beach Club l Makena Maka</div>
//               <div className="gameScore d-flex align-items-center gap-1 mt-1">Blue 34.80 / 122</div>
//               <div className="competitionSize">08/23/23</div>
//             </div>
//           </div>
//           <div className="leaderProfile">
//             <div className="row g-2">
//               <div className="col-sm-6 text-start">
//                 <div className="value">42</div>
//                 <div className="title">Round Score</div>
//               </div>
//               <div className="col-sm-6 text-sm-end">
//                 <div className="value">5.5</div>
//                 <div className="title">Handicap</div>
//               </div>
//             </div>
//           </div>
//           <Form className="">
//             <div className="row g-2">
//               <Form.Group className="col-sm-12">
//                 <Form.Control className="sahdow-none" type="text" placeholder="Enter leader board password" />
//               </Form.Group>
//             </div>
//             <div className="btnGroup d-flex flex-column flex-sm-row align-items-center gap-3 mt-4">
//               <button type="button" className="btn btnStyle1 btnOutlineTheme1 btnWidth shadow-none px-3 w-100 d-flex align-items-center gap-1 justify-content-center">Observe Only</button>
//               <button type="button" className="btn btnStyle1 btnTheme1 btnWidth shadow-none px-3 w-100">Join</button>
//             </div>
//           </Form>
//         </div>
//       </Modal.Body>
//     </Modal>
//     </Main>

//   );
// }
// export default CurrentLeaderboard;